<div *ngIf="detailLoading" class="container primary-page-wrapper py-5" aria-busy="true" aria-label="Restaurant">
  <div class="business-content-skeleton" style="height:32px; width:55%; border-radius:8px; margin-bottom:24px" aria-hidden="true"></div>
  <div class="business-content-skeleton" style="height:300px; border-radius:12px; margin-bottom:24px" aria-hidden="true"></div>
  <div class="business-content-skeleton" style="height:80px; border-radius:8px" aria-hidden="true"></div>
</div>
<div *ngIf="detailError && !detailLoading" class="container primary-page-wrapper business-unavailable" role="alert">
  <div class="business-unavailable-card">
    <span class="business-unavailable-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M7 2v8m-3-8v5a3 3 0 0 0 6 0V2M7 10v12M17 22V2c-2.2 1.3-3.5 3.9-3.5 7.5V14H17"/>
      </svg>
    </span>
    <h1 class="business-unavailable-title">This restaurant isn't available</h1>
    <p class="business-unavailable-text">It may no longer be listed, or the page couldn't load. Try again, or find another place nearby.</p>
    <div class="business-unavailable-actions">
      <button type="button" class="btn btn-primary" (click)="loadRestaurant()">Try again</button>
      <a routerLink="/listing" class="btn btn-outline-primary">Browse restaurants</a>
    </div>
  </div>
</div>
<div *ngIf="!detailLoading && !detailError" class="container landing-container primary-page-wrapper business-page-wrapper" [class.tour-guided-detail]="tour.active">
  <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" class="breadcrumb-block d-none d-lg-block">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="currentLocation?.city">{{currentLocation?.city}}</li>
      <li class="breadcrumb-item">
        {{
(businessDetails.typeName != null || businessDetails.typeName != undefined) ?
        businessDetails.typeName : 'Restaurants'
        }}
      </li>
      <li class="breadcrumb-item" aria-current="page" *ngIf="businessDetails?.name">{{businessDetails?.name}}</li>
    </ol>
  </nav>
  <app-business-detail-header [business]="businessDetails" (highlightMarker)="highlight($event)"
                              (defaultMarker)="removeHighlight($event)" [reviews]="reviewList"
                              [hasDeals]="whatsOnAvailable" (seeDeals)="seeDeals()"></app-business-detail-header>

  <div *ngIf="hasBusinessPhotos && photosLoading" class="business-content-skeleton" style="height:300px; border-radius:12px" aria-busy="true" aria-label="Business photos"></div>
  <img *ngIf="!hasBusinessPhotos" [businessImage]="null" alt="No business image" style="width:100%; height:300px; object-fit:contain" />
  <div #sliderWithThumbWrap class="slider-with-thumb-wrap" data-tour="photo-stage"
       [ngClass]="{'d-none': !isSliderExist, 'is-image-expanded': isImageExpanded}">
    <div class="navigation-wrap">

      <div class="keen-slider view-slide top-slider" #sliderRef>
        <div class="keen-slider__slide number-slide{{i+1}} defaultWidth"
             *ngFor="let imageArray of filteredGalleryImages; let i=index">
          <div class="keen-slider inner-slider defaultWidth" #sliderRefInner>
            <!-- The slide element must be a DIRECT child of the track. keen-slider finds
                 elements by its slide selector and sizes those, but the flex row only lays
                 out direct children, so an *ngFor wrapper in between left the real slides
                 unsized and the wrappers splitting the row: a category of N photos rendered
                 each at 1/N width, which also capped how tall they could grow when expanded. -->
            <div class="keen-slider__slide number-slide{{j+1}} defaultWidth"
                 *ngFor="let image of imageArray.images; let j=index">
              <div class="bg-img" *ngIf="image.croppedSrc || image.src">
                <img [attr.loading]="isTourPhotoVisible(i, j) ? 'eager' : 'lazy'" decoding="async" [businessImage]="galleryImageSource(i, j)" [businessImagePending]="!!image.src"
                     [attr.width]="isImageExpanded ? null : image?.pixelW"
                     [attr.height]="isImageExpanded ? null : image?.pixelH"
                     (load)="onExpandedImageLoad($event)"
                     (businessImageError)="onGalleryImageError(i, j, $event)"
                     [alt]="(businessDetails.name || 'Business') + ' — ' + (imageArray.category || 'photo')" />
                <button class="image-expand-btn"
                        type="button"
                        (click)="toggleImageExpand($event)"
                        [attr.aria-label]="isImageExpanded ? 'Collapse image size' : 'Expand image size'"
                        [attr.aria-pressed]="isImageExpanded">
                  <img src="./assets/images/ic-expand-image.svg" alt="" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-button class="d-sm-none" [btnCss]="
    'btn arrow arrow-prev ' +
    (currentSlide === 0 ? 'arrow--disabled' : '')
" (onBtnClick)="slider?.prev(); onTourPhotoInteraction()" [iconSrc]="'./assets/images/ic-slider-prev.svg'"></app-button>

      <app-button class="d-sm-none" [btnCss]="
    'btn arrow arrow-next ' +
    (slider?.track?.details?.slides.length - 1 === currentSlide
        ? 'arrow--disabled'
        : '')
" *ngIf="slider" (onBtnClick)="slider?.next(); onTourPhotoInteraction()" [iconSrc]="'./assets/images/ic-slider-next.svg'"></app-button>
      <div class="loader-wrapper inside-loader" [ngClass]="{'d-none': !isCaroselLoading}" style="z-index: 0;">
        <span class="loader"></span>
      </div>

    </div>
    <div class="thumb-wrap" [attr.data-tour]="tourPhotoRibbonReady ? 'photo-ribbon' : null">
      <div class="keen-slider thumbnail" #thumbnailRef>
        <app-slider-thumbnail *ngFor="let categoryImages of  filteredGalleryImages; let i=index"
                              class="keen-slider__slide number-slide{{i+1}}"
                              [attr.role]="tour.active ? 'button' : null" [attr.tabindex]="tour.active ? 0 : null"
                              [attr.aria-label]="'Browse ' + categoryImages.category + ' photos'"
                              (click)="onTourPhotoInteraction()" (keydown.enter)="onTourPhotoKey(i, $event)"
                              (keydown.space)="onTourPhotoKey(i, $event)" [imageSrc]="galleryThumbnailSource(i)"
                              (imageError)="onGalleryThumbnailError(i, $event)"
                              [slideText]="categoryImages.category"></app-slider-thumbnail>
      </div>
    </div>
  </div>

  <div class="location-map-frame">
    <div *ngIf="!mapsReady && hasMapLocation" class="business-content-skeleton" style="height:300px" aria-busy="true" aria-label="Map"></div>
    <google-map *ngIf="mapsReady && hasMapLocation" (mapInitialized)="onMapInitialized($event)" #GoogleMap class="google-map g-map" [center]="initialCoordinates" [options]="mapOptions">
    </google-map>

    <div class="link-wrap-outer">
      <div class="links-wrap">
        <div class="row">
          <div class="col-12">

            <p style="white-space: nowrap;">
              <span class="icon-wrap clock-icon">
                <img src="./assets/images/ic-clock-primary-light.svg" alt="" />
              </span>
              <ng-container *ngIf="formattedHours && formattedHours.length > 0; else noHours">
                <span>Open {{formattedHours?.length}} {{ formattedHours?.length === 1 ? 'day' : 'days' }},&nbsp;</span>
                <ng-container *ngFor="let hours of formattedHours; let i = index">
                  <ng-container *ngIf="i === 0">
                    <div>{{ hours + '&nbsp;'}}</div>
                    <!-- Hover where there is a mouse, tap where there is not — a hover-only
                         tooltip never opened on touch screens. Focusable for keyboards. -->
                    <div #hoursTip="ngbTooltip" [ngbTooltip]="hoursSlot" [triggers]="hoursTooltipTriggers" placement="top"
                         class="time-view-block pointer" tooltipClass="theme-tooltip timeslot-tooltip" container="body"
                         role="button" tabindex="0" aria-label="Show opening hours for every day"
                         (keydown.enter)="hoursTip.toggle()" (keydown.space)="hoursTip.toggle(); $event.preventDefault()"
                         *ngIf="formattedHours.length - 1 != 0">
                      +{{
 (formattedHours.length - 1 > 1) ?
                      formattedHours.length
                      - 1 + ' more slots' : formattedHours.length - 1 + ' more slot'
                      }}
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #noHours>{{'-'}}</ng-template>
            </p>
            <ng-template #hoursSlot>
              <table>
                <tbody>
                  <tr *ngFor="let item of toolTipHours; let i = index" class="tooltip-line">
                    <td>
                      <span class="tooltip-day">{{ item.day }}</span>
                    </td>
                    <td>
                      <span class="tooltip-time t-from">{{ item.from }}</span>
                    </td>
                    <td>
                      <span class="tooltip-separator">-</span>
                    </td>
                    <td>
                      <span class="tooltip-time t-to">{{ item.to }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
          <div class="col-12">
            <a [attr.href]="contactLinks.directions || null"
               [attr.target]="contactLinks.directions ? '_blank' : null"
               [attr.rel]="contactLinks.directions ? 'noopener noreferrer' : null"
               [attr.title]="contactLinks.directions ? 'Get directions' : null"
               [attr.aria-label]="contactLinks.directions ? 'Get directions to ' + businessDetails.name : null">
              <span class="icon-wrap location-icon">
                <img src="./assets/images/ic-location.svg" alt="" />
              </span>
              <span style="display: block;margin-top: 2px;" [class.text]="contactLinks.directions">
                {{ businessDetails.address || '-' }}
              </span>
            </a>
          </div>
          <!-- Every field stays on the page even when the business left it blank, so the
               block reads as a complete record. A row with no value shows "-" and carries
               no href: an empty `tel:` / `href=""` used to ship as a live link that
               reloaded the page. -->
          <div class="col-6">
            <a [attr.href]="contactLinks.tel || null"
               [attr.aria-label]="contactLinks.tel ? 'Call ' + businessDetails.phoneNumber : null">
              <span class="icon-wrap phone-icon">
                <img src="./assets/images/ic-phone.svg" alt="" />
              </span>
              {{ businessDetails.phoneNumber || '-' }}
            </a>
          </div>
          <div class="col-6">
            <a [attr.href]="contactLinks.website || null"
               [attr.target]="contactLinks.website ? '_blank' : null"
               [attr.rel]="contactLinks.website ? 'noopener noreferrer' : null">
              <span class="icon-wrap web-icon">
                <img src="./assets/images/ic-web.svg" alt="" />
              </span>
              <span [class.text]="contactLinks.website">website</span>
              <img *ngIf="contactLinks.website" src="./assets/images/ic-arrow-tr.svg" alt="" class="arrow" />
              <span *ngIf="!contactLinks.website" class="arrow">-</span>
            </a>
          </div>
          <div class="col-6">
            <a [attr.href]="contactLinks.instagram || null"
               [attr.target]="contactLinks.instagram ? '_blank' : null"
               [attr.rel]="contactLinks.instagram ? 'noopener noreferrer' : null">
              <span class="icon-wrap twitter-icon twitter-icon-wrap">
                <img src="./assets/images/ic-instagram.svg" alt="" />
              </span>
              <span [class.text]="contactLinks.instagram">instagram</span>
              <img *ngIf="contactLinks.instagram" src="./assets/images/ic-arrow-tr.svg" alt="" class="arrow" />
              <span *ngIf="!contactLinks.instagram" class="arrow">-</span>
            </a>
          </div>
          <div class="col-6">
            <a [attr.href]="contactLinks.twitter || null"
               [attr.target]="contactLinks.twitter ? '_blank' : null"
               [attr.rel]="contactLinks.twitter ? 'noopener noreferrer' : null">
              <span class="icon-wrap twitter-icon twitter-icon-wrap">
                <img src="./assets/images/ic-twitter.svg" alt="" />
              </span>
              <span [class.text]="contactLinks.twitter">twitter</span>
              <img *ngIf="contactLinks.twitter" src="./assets/images/ic-arrow-tr.svg" alt="" class="arrow" />
              <span *ngIf="!contactLinks.twitter" class="arrow">-</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" [class.tour-guided-menu]="tour.active && tour.step === 'menu'">
    <div class="col-lg-8 order-1 order-lg-0 tour-menu-column">
      <div class="food-menu-top-nav" #tourMenuHost data-tour="menu-section">
        <div class="food-menu-top-inner">
          <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills">
            <ng-container ngbNavItem="top">
              <button ngbNavLink>
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.36378 6.18358L5.13986 4.46906L0.734179 0.222135C0.264019 0.677308 0 1.29387 0 1.93666C0 2.57944 0.264019 3.19601 0.734179 3.65118L3.36378 6.18358ZM7.61884 5.08702C8.57906 5.51716 9.92837 5.21424 10.9262 4.25096C12.1249 3.09381 12.3571 1.43381 11.4346 0.543229C10.5183 -0.341295 8.79871 -0.123193 7.59374 1.03396C6.59587 1.99724 6.28208 3.29979 6.72766 4.22673L0.602385 10.1397L1.48729 10.9939L5.81138 6.83183L10.1292 11L11.0141 10.1458L6.69628 5.9776L7.61884 5.08702Z"
                        fill="currentcolor" />
                </svg>
                Menu
              </button>
              <ng-template ngbNavContent>
                <div *ngIf="menuLoading" class="business-content-skeleton" style="height:160px; border-radius:8px" aria-busy="true" aria-label="Menu"></div>
                <p *ngIf="!menuLoading && !menuError && !menuCategories.length" class="py-3">The menu hasn't been added yet.</p>
                <div class="data-showcase-grid food-dish-grid">
                  <div class="food-tab-outer">
                    <ul ngbNav #dishNav="ngbNav" [(activeId)]="activeCategoryPanel" class="nav-tabs">
                      <ng-container *ngFor="let category of menuCategories; let i=index; trackBy: trackByEntityId">
                        <li [ngbNavItem]="category.id" (click)="getProductsByCategoryId(category.id)">
                          <button ngbNavLink>
                            {{category.title}}
                            <span class="photo-count">{{productCountByCategory[category.id] || 0}}</span>
                          </button>
                          <ng-template ngbNavContent>
                            <div class="food-dish-wrap">
                              <ul class="dish-ul" *ngIf="isMobile">
                                <ng-container *ngFor="let product of products; let m=index; trackBy: trackByEntityId">
                                  <li [class.selected]="selectedProduct?.id == product.id" *ngIf="product.productCategoryId === category.id" [attr.data-tour]="tour.active && isTourImageReady(product.productImageUrl) ? 'menu-item' : null"
                                        [attr.role]="tour.active ? 'button' : null" [attr.tabindex]="tour.active ? 0 : null"
                                        [attr.aria-expanded]="tour.active ? selectedProduct?.id == product.id : null"
                                        (keydown.enter)="onTourMenuKey(product, m, $event)"
                                        (keydown.space)="onTourMenuKey(product, m, $event)"
                                        (click)="selectProduct(product, m)">
                                    <app-menu-section [showButtons]="false" [menuTypes]="menuCategories" [currencySymbol]="businessDetails.sourceCurrency"
                                                      [productImageId]="product.productImageId" [product]="product"
                                                      style="display: flex; width: 100%"></app-menu-section>
                                  </li>
                                  <ng-container *ngIf="selectedIndex === m && selectedProduct.productCategoryId === category.id">
                                    <div class="item-card-mobile" [attr.data-tour]="tour.active ? 'menu-detail' : null">
                                      <img class="item-img-mobile" [businessImage]="selectedProduct.productImageUrl"
                                           alt="item" (load)="onTourMenuExpandedLoad($event)" />
                                      <div class="item-info-mobile mt-3">
                                        <h3 class="item-title">
                                          {{selectedProduct.title}}
                                        </h3>
                                        <p class="item-description"> {{selectedProduct.description}}</p>
                                      </div>
                                      <div class="item-price-mobile">{{businessDetails.sourceCurrency + ' ' + selectedProduct.price}}</div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ul>
                              <ul class="dish-ul" *ngIf="isTablet || isDesktop">
                                <ng-container *ngFor="let product of filterProducts; let j=index; trackBy: trackByEntityId">
                                  <ng-container *ngIf="j % 2 === 0">
                                    <li [class.selected]="selectedProduct?.id == filterProducts[j].id" *ngIf="product.productCategoryId === category.id && j % 2 === 0" [attr.data-tour]="tour.active && isTourImageReady(filterProducts[j].productImageUrl) ? 'menu-item' : null"
                                        [attr.role]="tour.active ? 'button' : null" [attr.tabindex]="tour.active ? 0 : null"
                                        [attr.aria-expanded]="tour.active ? selectedProduct?.id == filterProducts[j].id : null"
                                        (keydown.enter)="onTourMenuKey(filterProducts[j], j, $event)"
                                        (keydown.space)="onTourMenuKey(filterProducts[j], j, $event)"
                                        (click)="selectProduct(filterProducts[j], j)">
                                      <app-menu-section [showButtons]="false" [menuTypes]="menuCategories" [currencySymbol]="businessDetails.sourceCurrency"
                                                        [productImageId]="filterProducts[j].productImageId" [product]="filterProducts[j]"
                                                        style="display: flex; width: 100%"></app-menu-section>
                                    </li>
                                    <li [class.selected]="selectedProduct?.id == filterProducts[j+1].id" *ngIf="product.productCategoryId === category.id && j+1 % 2 !== 0 && filterProducts[j+1]" [attr.data-tour]="tour.active && isTourImageReady(filterProducts[j+1].productImageUrl) ? 'menu-item' : null"
                                        [attr.role]="tour.active ? 'button' : null" [attr.tabindex]="tour.active ? 0 : null"
                                        [attr.aria-expanded]="tour.active ? selectedProduct?.id == filterProducts[j+1].id : null"
                                        (keydown.enter)="onTourMenuKey(filterProducts[j+1], j+1, $event)"
                                        (keydown.space)="onTourMenuKey(filterProducts[j+1], j+1, $event)"
                                        (click)="selectProduct(filterProducts[j+1], j+1)">
                                      <app-menu-section [showButtons]="false" [menuTypes]="menuCategories" [currencySymbol]="businessDetails.sourceCurrency"
                                                        [productImageId]="filterProducts[j+1].productImageId" [product]="filterProducts[j+1]"
                                                        style="display: flex; width: 100%"></app-menu-section>
                                    </li>
                                    <ng-container *ngIf="selectedIndex === j && selectedProduct.productCategoryId === category.id && filterProducts[j]">
                                      <div class="item-card" [attr.data-tour]="tour.active ? 'menu-detail' : null">
                                        <img [businessImage]="selectedProduct.productImageUrl"
                                             alt="item" class="item-img" (load)="onTourMenuExpandedLoad($event)" />
                                        <div class="item-info">
                                          <h3 class="item-title">
                                            {{selectedProduct.title}}
                                          </h3>
                                          <p class="item-description"> {{selectedProduct.description}}</p>
                                        </div>
                                        <div class="item-price">{{businessDetails.sourceCurrency + ' ' + selectedProduct.price}}</div>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="selectedIndex === j+1 && selectedProduct.productCategoryId === category.id && filterProducts[j+1]">
                                      <div class="item-card" [attr.data-tour]="tour.active ? 'menu-detail' : null">
                                        <img [businessImage]="selectedProduct.productImageUrl"
                                             alt="item" class="item-img" (load)="onTourMenuExpandedLoad($event)" />
                                        <div class="item-info">
                                          <h3 class="item-title">
                                            {{selectedProduct.title}}
                                          </h3>
                                          <p class="item-description"> {{selectedProduct.description}}</p>
                                        </div>
                                        <div class="item-price">{{businessDetails.sourceCurrency + ' ' + selectedProduct.price}}</div>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                              </ul>
                              <p class="text-center" *ngIf="checkNoRecord(category.id) && products.length > 0">No Record Found!</p>
                              <p class="text-center p-top-135 restaurant-check-back-soon-text" *ngIf="products == null || products == undefined || products.length == 0">
                                Looks like this restaurant's still cooking up their menu!<br />
                                Check back soon to see what's on the plate.<br /><br />
                                <span *ngIf="businessDetails.approval === 9">If you are the owner of this business, please <a class="click-here" (click)="openWhatsApp()">click here</a></span>
                              </p>
                            </div>
                          </ng-template>
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                  <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
                </div>
              </ng-template>
            </ng-container>
            <!-- Paid What's On placement. Kept alive between tab switches so loaded posts stay put. -->
            <ng-container ngbNavItem="whats-on" *ngIf="whatsOnAvailable" [destroyOnHide]="false">
              <button ngbNavLink #whatsOnNavLink class="whats-on-nav-link" [class.is-beckoning]="whatsOnBeckon"
                      (click)="onWhatsOnTabOpened()">
                <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <path fill="currentColor" d="M13 2.2v11.6a.7.7 0 0 1-1.1.6L8.6 12H6.6l.6 2.3a.8.8 0 0 1-.8 1H5.1a.8.8 0 0 1-.8-.6L3.3 12h-.8A1.5 1.5 0 0 1 1 10.5v-5A1.5 1.5 0 0 1 2.5 4h6.1l3.3-2.4a.7.7 0 0 1 1.1.6Zm1.5 4a.75.75 0 0 1 .75.75v2.1a.75.75 0 0 1-1.5 0v-2.1a.75.75 0 0 1 .75-.75Z"/>
                </svg>
                What's On
              </button>
              <ng-template ngbNavContent>
                <app-whats-on-trail [branchId]="businessDetails.branchId" [businessName]="businessDetails.name"></app-whats-on-trail>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem="bottom">
              <button ngbNavLink tooltipClass="tooltip-custom">
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.741789 10.2558L0.379189 10.5948L0.741789 10.2558C0.590387 10.0939 0.5 9.86749 0.5 9.625V8.70833C0.5 8.46584 0.590387 8.23947 0.741789 8.07756C0.892129 7.91678 1.08858 7.83333 1.28571 7.83333H3.85714C4.05428 7.83333 4.25073 7.91678 4.40107 8.07756C4.55247 8.23947 4.64286 8.46584 4.64286 8.70833V9.625C4.64286 9.86749 4.55247 10.0939 4.40107 10.2558C4.25073 10.4166 4.05428 10.5 3.85714 10.5H1.28571C1.08857 10.5 0.892129 10.4166 0.741789 10.2558ZM0.741789 0.744225C0.89213 0.583444 1.08858 0.5 1.28571 0.5H10.7143C10.9114 0.5 11.1079 0.583444 11.2582 0.744225C11.4096 0.906141 11.5 1.13251 11.5 1.375V4.125C11.5 4.36749 11.4096 4.59386 11.2582 4.75577C11.1079 4.91656 10.9114 5 10.7143 5H1.28571C1.08858 5 0.892129 4.91656 0.741789 4.75577C0.590387 4.59386 0.5 4.36749 0.5 4.125V1.375C0.5 1.13251 0.590387 0.906141 0.741789 0.744225ZM7.59893 8.07756C7.74927 7.91678 7.94572 7.83333 8.14286 7.83333H10.7143C10.9114 7.83333 11.1079 7.91678 11.2582 8.07756C11.4096 8.23947 11.5 8.46584 11.5 8.70833V9.625C11.5 9.86749 11.4096 10.0939 11.2582 10.2558C11.1079 10.4166 10.9114 10.5 10.7143 10.5H8.14286C7.94572 10.5 7.74927 10.4166 7.59893 10.2558C7.44753 10.0939 7.35714 9.86749 7.35714 9.625V8.70833C7.35714 8.46584 7.44753 8.23947 7.59893 8.07756Z"
                        stroke="currentcolor" />
                </svg>
                Feed
              </button>
              <ng-template ngbNavContent>
                <div *ngIf="reviewsLoading" class="business-content-skeleton" style="height:100px; border-radius:8px" aria-busy="true" aria-label="Reviews"></div>
                <div class="data-showcase-grid public-review-grid">
                  <div class="public-review-wrap">
                    <div class="review-wrap-body" *ngFor="let item of reviewList; let i=index">
                      <app-review [review]="item"></app-review>

                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem="middle">
              <button ngbNavLink tooltipClass="tooltip-custom" (click)="preparePhotoCategory()">
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.38975 1.36086L3.05663 2.35714H2.03125C1.49253 2.35714 0.975873 2.56409 0.594939 2.93247C0.214006 3.30084 0 3.80047 0 4.32143V9.03571C0 9.55667 0.214006 10.0563 0.594939 10.4247C0.975873 10.793 1.49253 11 2.03125 11H10.9688C11.5075 11 12.0241 10.793 12.4051 10.4247C12.786 10.0563 13 9.55667 13 9.03571V4.32143C13 3.80047 12.786 3.30084 12.4051 2.93247C12.0241 2.56409 11.5075 2.35714 10.9688 2.35714H9.94256L9.61025 1.36086C9.47823 0.965376 9.21991 0.620574 8.87244 0.376043C8.52496 0.131512 8.10624 -0.000147407 7.6765 1.23852e-07H5.3235C4.89376 -0.000147407 4.47504 0.131512 4.12756 0.376043C3.78009 0.620574 3.52177 0.965376 3.38975 1.36086ZM2.03125 3.14286H3.64812L4.16244 1.60286C4.24154 1.36545 4.39648 1.15843 4.60497 1.01159C4.81347 0.864756 5.06476 0.785669 5.32269 0.785714H7.67731C7.9351 0.785835 8.18621 0.864999 8.39454 1.01183C8.60287 1.15865 8.7577 1.36558 8.83675 1.60286L9.35106 3.14286H10.9688C11.292 3.14286 11.602 3.26703 11.8305 3.48805C12.0591 3.70908 12.1875 4.00885 12.1875 4.32143V9.03571C12.1875 9.34829 12.0591 9.64806 11.8305 9.86909C11.602 10.0901 11.292 10.2143 10.9688 10.2143H2.03125C1.70802 10.2143 1.39802 10.0901 1.16946 9.86909C0.940904 9.64806 0.8125 9.34829 0.8125 9.03571V4.32143C0.8125 4.00885 0.940904 3.70908 1.16946 3.48805C1.39802 3.26703 1.70802 3.14286 2.03125 3.14286Z"
                        fill="currentcolor" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M4.0625 6.28585C4.0625 6.91101 4.31931 7.51056 4.77643 7.95261C5.23355 8.39466 5.85353 8.643 6.5 8.643C7.14647 8.643 7.76645 8.39466 8.22357 7.95261C8.68069 7.51056 8.9375 6.91101 8.9375 6.28585C8.9375 5.6607 8.68069 5.06115 8.22357 4.6191C7.76645 4.17705 7.14647 3.92871 6.5 3.92871C5.85353 3.92871 5.23355 4.17705 4.77643 4.6191C4.31931 5.06115 4.0625 5.6607 4.0625 6.28585ZM8.125 6.28585C8.125 6.70262 7.95379 7.10232 7.64905 7.39702C7.3443 7.69172 6.93098 7.85728 6.5 7.85728C6.06902 7.85728 5.6557 7.69172 5.35095 7.39702C5.04621 7.10232 4.875 6.70262 4.875 6.28585C4.875 5.86909 5.04621 5.46939 5.35095 5.17469C5.6557 4.87999 6.06902 4.71443 6.5 4.71443C6.93098 4.71443 7.3443 4.87999 7.64905 5.17469C7.95379 5.46939 8.125 5.86909 8.125 6.28585Z"
                        fill="currentcolor" />
                </svg>
                Photos
              </button>
              <ng-template ngbNavContent>
                <div class="data-showcase-grid gallery-grid">
                  <div class="photo-tab-wrap">
                    <ul ngbNav #photoNav="ngbNav" [(activeId)]="activePhotoPanel" class="nav-tabs">
                      <ng-container *ngFor="let categoryImages of images; let i=index">
                        <li [ngbNavItem]="i" (click)="preparePhotoCategory(i)">
                          <button ngbNavLink>
                            {{categoryImages.category}}
                            <span class="photo-count">{{categoryImages.images.length}}</span>
                          </button>
                          <ng-template ngbNavContent>
                            <div class="photo-tab-wrap">
                              <div class="row">
                                <ng-container *ngFor="let photo of categoryImages.images">
                                  <div class="col-sm-6 col-md-4">
                                    <app-photos-section [imageUrl]="photo.croppedSrc ? photo.croppedSrc : photo.src" [showButtons]="false"
                                                        class="col-sm-6 col-md-4"></app-photos-section>
                                  </div>
                                </ng-container>
                                <p class="text-center" *ngIf="categoryImages.images?.length == 0">No Record Found!</p>
                              </div>
                            </div>
                          </ng-template>
                        </li>
                      </ng-container>
                    </ul>
                    <div [ngbNavOutlet]="photoNav" class="mt-2"></div>
                  </div>

                </div>
              </ng-template>
            </ng-container>
            <!--<a class="btn btn-demo" [routerLink]="['/gallery',businessDetails.branchId]" ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
              <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.38975 1.36086L3.05663 2.35714H2.03125C1.49253 2.35714 0.975873 2.56409 0.594939 2.93247C0.214006 3.30084 0 3.80047 0 4.32143V9.03571C0 9.55667 0.214006 10.0563 0.594939 10.4247C0.975873 10.793 1.49253 11 2.03125 11H10.9688C11.5075 11 12.0241 10.793 12.4051 10.4247C12.786 10.0563 13 9.55667 13 9.03571V4.32143C13 3.80047 12.786 3.30084 12.4051 2.93247C12.0241 2.56409 11.5075 2.35714 10.9688 2.35714H9.94256L9.61025 1.36086C9.47823 0.965376 9.21991 0.620574 8.87244 0.376043C8.52496 0.131512 8.10624 -0.000147407 7.6765 1.23852e-07H5.3235C4.89376 -0.000147407 4.47504 0.131512 4.12756 0.376043C3.78009 0.620574 3.52177 0.965376 3.38975 1.36086ZM2.03125 3.14286H3.64812L4.16244 1.60286C4.24154 1.36545 4.39648 1.15843 4.60497 1.01159C4.81347 0.864756 5.06476 0.785669 5.32269 0.785714H7.67731C7.9351 0.785835 8.18621 0.864999 8.39454 1.01183C8.60287 1.15865 8.7577 1.36558 8.83675 1.60286L9.35106 3.14286H10.9688C11.292 3.14286 11.602 3.26703 11.8305 3.48805C12.0591 3.70908 12.1875 4.00885 12.1875 4.32143V9.03571C12.1875 9.34829 12.0591 9.64806 11.8305 9.86909C11.602 10.0901 11.292 10.2143 10.9688 10.2143H2.03125C1.70802 10.2143 1.39802 10.0901 1.16946 9.86909C0.940904 9.64806 0.8125 9.34829 0.8125 9.03571V4.32143C0.8125 4.00885 0.940904 3.70908 1.16946 3.48805C1.39802 3.26703 1.70802 3.14286 2.03125 3.14286Z"
                      fill="currentcolor" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4.0625 6.28585C4.0625 6.91101 4.31931 7.51056 4.77643 7.95261C5.23355 8.39466 5.85353 8.643 6.5 8.643C7.14647 8.643 7.76645 8.39466 8.22357 7.95261C8.68069 7.51056 8.9375 6.91101 8.9375 6.28585C8.9375 5.6607 8.68069 5.06115 8.22357 4.6191C7.76645 4.17705 7.14647 3.92871 6.5 3.92871C5.85353 3.92871 5.23355 4.17705 4.77643 4.6191C4.31931 5.06115 4.0625 5.6607 4.0625 6.28585ZM8.125 6.28585C8.125 6.70262 7.95379 7.10232 7.64905 7.39702C7.3443 7.69172 6.93098 7.85728 6.5 7.85728C6.06902 7.85728 5.6557 7.69172 5.35095 7.39702C5.04621 7.10232 4.875 6.70262 4.875 6.28585C4.875 5.86909 5.04621 5.46939 5.35095 5.17469C5.6557 4.87999 6.06902 4.71443 6.5 4.71443C6.93098 4.71443 7.3443 4.87999 7.64905 5.17469C7.95379 5.46939 8.125 5.86909 8.125 6.28585Z"
                      fill="currentcolor" />
              </svg>
              Gallery
            </a>-->
          </div>
          <div class="btn-grps-outer d-none d-md-flex">
            <button disabled class="btn btn-blue" ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
              <img src="./assets/images/ic-points.svg" alt="Icon" />
              55 points
            </button>
            <button disabled class="btn btn-danger btn-order" title="Order Here!" ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
              Order Here!
            </button>
          </div>
        </div>

        <div [ngbNavOutlet]="nav" class=""></div>
      </div>
    </div>
    <div class="col-lg-4 order-0 order-lg-1">
      <div class="advertisement-wrapper">
        <div class="row" *ngFor="let img of selectedImages">
          <app-advertisement [imageUrl]="img"
                             class="'col-sm-6 col-lg-12'"></app-advertisement>
        </div>
      </div>
    </div>
  </div>
</div>
